"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichArticle = void 0;
var Article_1 = require("./Article");
var RichArticle = /** @class */ (function (_super) {
    __extends(RichArticle, _super);
    function RichArticle(params) {
        var _a, _b;
        var _this = _super.call(this, __assign(__assign({}, params), { idProduct: (_b = (_a = params.card) === null || _a === void 0 ? void 0 : _a._id) !== null && _b !== void 0 ? _b : params.idProduct })) || this;
        var card = params.card;
        if (card) {
            var _id = card._id, cn = card.cn, rarity = card.rarity, name = card.name, set = card.set, expansion = card.expansion, onlyFoil = card.onlyFoil, locNames = card.locNames, rarityStr = card.rarityStr, expansionReleaseDate = card.expansionReleaseDate, categoryName = card.categoryName;
            _this.card = {
                _id: _id,
                cn: cn,
                rarity: rarity,
                name: name,
                set: set,
                expansion: expansion,
                onlyFoil: onlyFoil,
                locNames: locNames,
                rarityStr: rarityStr,
                expansionReleaseDate: expansionReleaseDate,
                categoryName: categoryName
            };
        }
        else {
            throw new Error('invalid card data');
        }
        return _this;
    }
    Object.defineProperty(RichArticle.prototype, "id", {
        get: function () {
            return this.idArticle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RichArticle.prototype, "isColdFoil", {
        /**
         * Flesh and Blood cold foil
         */
        get: function () {
            return this.card.name.includes('(Cold Foil)');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RichArticle.prototype, "isRainbowFoil", {
        /**
         * Flesh and Blood rainbow foil
         */
        get: function () {
            return this.card.name.includes('(Rainbow Foil)');
        },
        enumerable: false,
        configurable: true
    });
    RichArticle.prototype.toPlainObject = function () {
        return __assign(__assign({}, _super.prototype.toPlainObject.call(this)), { card: this.card, id: this.id });
    };
    RichArticle.prototype.copy = function () {
        return new RichArticle(__assign({}, this.toPlainObject()));
    };
    return RichArticle;
}(Article_1.Article));
exports.RichArticle = RichArticle;
//# sourceMappingURL=RichArticle.js.map